import Vue from "vue";

/**
 * Finds a record in a collection matching the given id, or calls the callback if not found.
 * @param {Array} collection - items that respond to `typeOfId + "_id"`
 * @param {string} typeOfId - type prefix, e.g. "actor" matches `actor_id`
 * @param {number} id - e.g. pp.currentActorId
 * @param {Function} [cb] - called when no record is found, e.g. `() => ({ blank: obj })`
 * @returns {Object|undefined}
 */
export function findInCollectionOr(collection, typeOfId, id, cb) {
	const found = _.find(collection, (item) => {
		return item[typeOfId + "_id"] === id;
	});
	if (found) {
		return found;
	} else if (cb !== undefined) {
		return cb();
	} else {
		return undefined;
	}
}

function loadPersistingInstances($container = $("body")) {
	// pp.log("into loadPersistingInstances");
	pp.vue.persistingInstances = [];
	Array.from($container.find(".persisting-vue-instance")).forEach((element) => {
		const pi = new Vue({
			el: element,
			mounted() {
				pp.log("Mounted vue PERSISTING instance:", element);
			},
			beforeDestroy() {
				pp.log(
					"Unmounting vue PERSISTING instance from loadPersistingInstances beforeDestroy:",
					element,
				);
			},
		});
		// @ts-expect-error
		pp.vue.persistingInstances.push(pi);
		window.addEventListener("beforeunload", function () {
			// pp.log("into loadPersistingInstances beforeunload listener")
			// @ts-expect-error
			pp.vue.persistingInstances.forEach((instance) => {
				instance.$destroy();
			});
		});
	});
}

export function lazyLoadPageVueInstances($container) {
	const $instancesInContainer = $container.find(".page-vue-instance--lazy");
	// pp.log("VUE: Loading ${cssSelector} in container, instances:", $container, $instancesInContainer);
	// pp.log("VUE: existing instances:", pp.vue.pageInstances);
	$instancesInContainer.each((index, element) => {
		const existingInstance = element.__vue__;

		if (existingInstance !== undefined) {
			//console.error("Trying to Lazy load an existing vue instance:", existingInstance.$el);
			return;
		}
		const newInstance = new Vue({ el: element });

		// pp.log("mounted lazy", newInstance.$el);
		$(newInstance.$el).one("destroyed destroyed_proxy", (event) => {
			destroyVueInstance(event.currentTarget);
		});

		$(element)
			.removeClass("page-vue-instance--lazy")
			.addClass("page-vue-instance");
	});
}

function loadPageVueInstances($container = $("body")) {
	const $instancesInContainer = $container.find(".page-vue-instance");
	// pp.log("VUE: Loading ${cssSelector} in container, instances:", $container, $instancesInContainer);
	$instancesInContainer.each((index, element) => {
		// @ts-expect-error
		const existingInstance = element.__vue__;

		if (existingInstance !== undefined) {
			// pp.log("already existing instance:", existingInstance.$el);
			return;
		}

		const newInstance = new Vue({ el: element });
		// pp.log("mounted", newInstance.$el);

		$(newInstance.$el).one("destroyed destroyed_proxy", (event) => {
			destroyVueInstance(event.currentTarget);
		});
	});
}

export function groupBy(arr, f) {
	return arr.reduce((out, val) => {
		const by = typeof f === "function" ? "" + f(val) : val[f];
		(out[by] = out[by] || []).push(val);
		return out;
	}, {});
}

function destroyVueInstance(element) {
	const vueId = element.dataset["vueId"];
	// pp.log("VUE into destroyVueInstance", element, vueId);
	if (!element.__vue__) {
		return;
	}
	// pp.log("VUE destroyVueInstance executing -- vueId, element", vueId, element);
	element.__vue__.$destroy();
}

/*
 * Sets up the listeners for the persistant vue, and page vue instance creating and
 * destruction
 */
export function setUpVueInstances() {
	$("body").ready(() => {
		// pp.log("VUE: Loading persisting instances from body ready")
		loadPersistingInstances();
	});

	$(document).on("page:before-unload", function (e) {
		// pp.log("VUE Page unloading", e);
		// pp.log("unloading persisting vue instances on page:before-unload");
		_.each(pp.vue.persistingInstances, (instance) => {
			instance.$destroy();
		});
		pp.vue.persistingInstances = [];
	});

	$(document).on("page:change", (e, opts) => {
		if (opts && opts.noVue) {
			return;
		}
		loadPageVueInstances();
	});

	$(document).on("page:load", (e) => {
		// pp.log("VUE: Loading persisting instances from page:load");
		loadPersistingInstances();
	});
}

export function emitJsonForVue(object, action, klass) {
	const klassName = klass ? klass : object.klass;
	pp.log("Emitting JSON for vue:", klassName, action, object);
	pp.vue.bus.$emit(`${klassName}-${action.toUpperCase()}`, object);
}

/**
 * Given a value in a range (min, max), calculate the percentage the min -> value range is
 * within the greater range. ie. [-#--] min 1 max 4 value 2s
 * @param {Number} value a value within the min and max
 * @param {Number} min the lower end of the range e.g. -100
 * @param {Number} max the upper end of the range e.g. 100
 */
export function percentOfValueInRange(value, min, max) {
	return ((value - min) / (max - min)) * 100;
}

// JS of `percentage_change_helper`
export function percentageChange(from, to) {
	if (from == 0 && to == 0) {
		return null;
	} else if (from == 0) {
		return to < 0 ? -Infinity : Infinity;
	} else if (to == 0) {
		return -Infinity;
	} else {
		return Math.round(((to - from) / from) * 10000) / 100; // Efectively round to 2 decimal places
	}
}

/**
 * Given a string, translate it with the rails I18n-js gem
 * May eventually require expansion to include all the options the rails gem allows
 */
export const i18n = {
	methods: {
		t(string, options) {
			return window.I18n.t(string, options);
		},
	},
};

export function mountElementsInContainer($container) {
	// pp.log("mounting", $container);
	loadPersistingInstances($container);
	loadPageVueInstances($container);
}

/** @this {any} */
export function debounceAdminFetchActorsVueData(actorIds, callback) {
	if (this.queuedActorIds === undefined) {
		this.queuedActorIds = [];
	}
	// pp.log("debounceAdminFetchActorsVueData", actorIds, this.queuedActorIds);
	this.queuedActorIds = [...new Set([...this.queuedActorIds, ...actorIds])]; // Merge without duplicates
	if (this.fetchActorsVueDataTimeout !== null) {
		clearTimeout(this.fetchActorsVueDataTimeout);
	}
	this.fetchActorsVueDataTimeout = setTimeout(() => {
		$.ajax({
			url: "/admin_fetch_actors_vue_data",
			type: "GET",
			data: { actor_ids: this.queuedActorIds },
			async: false,
			success: (actorsData) => {
				callback(actorsData);
				this.queuedActorIds = [];
			},
		});
	}, 25);
}
